import { getCurrentRoute, endTiming } from './utils';
import overrideNavigation from './overrideNavigation';
import popstateListener from './routeListener';

export function registerPageLoader() {

  popstateListener();

  overrideNavigation();
}

export default function pageViewTrack() {
  const route = getCurrentRoute();
  if (route) {
    let options = {};
    const page_load_time = endTiming(route);
    if (page_load_time > 0) {
      options.page_load_time = page_load_time;
    }
    this.track('pageview', '页面浏览', options);
  }
}
